import { Component, OnInit, HostListener, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { GlobalValuesService } from 'app/services/global-values.service';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { unsavedFormCheck } from 'app/shared/validators/generic-validators';

import { GoogleSearchResultsComponent } from '../googlesearchresults/google-search-results.component';

import { CreateOrganisationService } from './create-organisation.service';

@Component({
    selector: 'create-organisation',
    providers: [CreateOrganisationService],
    templateUrl: './create-organisation.component.html'
})

/**
 * Component to add new Organisation.
 */
export class CreateOrganisationComponent implements OnInit {
    orgName = '';
    orgRegisterCode = '';
    orgIncorporateDate: Date;
    orgLegalStructure: number;
    orgStockExchange = '';
    orgISIN = '';
    orgIsSpecialFI = false;
    selectedIndex: 0;
    subscription: any;
    savingOrganisation = false;
    public stockExchangeDropDown: ApplicationValue[];
    redirectAfterCreate = true;

    @ViewChild(GoogleSearchResultsComponent)
    private searchComponent: GoogleSearchResultsComponent;
    @ViewChild('orgAddForm') orgAddForm;

    constructor(
        private createOrganisationService: CreateOrganisationService,
        private warmUpService: WarmUpService,
        private dialogRef: MdDialogRef<CreateOrganisationComponent>,
        private cdr: ChangeDetectorRef,
        private dialog: MdDialog,
        private snackBarService: SnackBarService,
        private globalValuesService: GlobalValuesService,
        private router: Router,
        private trackingService: TrackingService) { }

    ngOnInit() {
        this.setUpExchangeValues(this.warmUpService.getApplicationValue(ApplicationTypeConstants.STOCK_EXCHANGE));
    }

    setUpExchangeValues(dropDownValues: any) {
        if (dropDownValues instanceof Observable) {
            dropDownValues.subscribe(
                response => {
                    this.warmUpService.setApplicationTypeInLS(response);
                    this.stockExchangeDropDown = response.values;
                    this.cdr.detectChanges();
                }
            );
        } else {
            this.stockExchangeDropDown = dropDownValues;
        }
    }

    selectedIndexChange(tabIndex) {
        this.selectedIndex = tabIndex;
        this.searchComponent.setSearchText(this.orgName);
        this.searchComponent.loadData(null);
    }

    toggleTab(tabIndex) {
        this.selectedIndex = tabIndex;
    }

    saveEnabled() {
        return this.orgName && this.globalValuesService.gblLegalStructureSelectedIDValue;
    }

    saveOrg() {
        if (this.globalValuesService.gblLegalStructureSelectedIDValue) {
            this.orgLegalStructure = this.globalValuesService.gblLegalStructureSelectedIDValue;
        }
        const postOrgData = {
            'organisationname': this.orgName,
            'legalstructure': this.orgLegalStructure,
            'registrationcode': this.orgRegisterCode,
            'incorporationdate': this.orgIncorporateDate || '',
            'stockexchange': this.orgStockExchange,
            'isin': this.orgISIN,
            'specialfinancialinstitution': this.orgIsSpecialFI
        };
        this.savingOrganisation = true;

        this.createOrganisationService.addOrg(postOrgData)
            .subscribe(
            success => {
                this.savingOrganisation = false;
                this.callSnackBarService(success);
                const orgId = success.arrResult.id;
                if (this.redirectAfterCreate) {
                    this.router.navigate(['/entity', success.arrResult.entityId, 'details']);
                }
                this.dialogRef.close(success.arrResult);
                this.trackingService
                    .emitEvent(TrackingConstants.CREATE_ORGANISATION, TrackingConstants.SAVE_ORGANISATION, TrackingConstants.SUCCESS, 1);
            },
            err => {
                this.savingOrganisation = false;
                this.callSnackBarService(err);
                this.trackingService
                    .emitEvent(TrackingConstants.CREATE_ORGANISATION, TrackingConstants.SAVE_ORGANISATION, TrackingConstants.FAILURE, 0);
            }
            );
    }

    callSnackBarService(response: any) {
        this.snackBarService
            .showStatus(response,
            MessageService.CREATE_ORG_SUCCESS,
            MessageService.CREATE_ORG_FAILURE);
    }

    @HostListener('keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        unsavedFormCheck(event, this.dialogRef, this.orgAddForm);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/createorganisation/create-organisation.component.ts